let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("87F9B"), load("4aLlP"), load("aZinD"), load("hrAMe"), load("KsAVd"), load("f9WnJ")]).then(() => parcelRequire('gVFlX'));